import { render, staticRenderFns } from "./AppSnackBarContent.vue?vue&type=template&id=3ba4be61"
import script from "./AppSnackBarContent.vue?vue&type=script&lang=js"
export * from "./AppSnackBarContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports